<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.aimbSerialNumber" style="width: 130px" size="mini"
                        placeholder="请输入手册序列号"></el-input>
                    <el-select v-model="formDatas.auName" placeholder="请选择姓名"  size="mini" filterable clearable  
                        @change="partserch">
                        <el-option v-for="(item, index) in auNamesList || []" :label="item" :value="item" :key="index">
                        </el-option>
                    </el-select>
                    <el-input v-model="formDatas.aimbrHandlerUser" style="width: 130px" size="mini"
                        placeholder="请输入归还经手人"></el-input>
                    <el-select v-model="formDatas.aimbrStatus" clearable placeholder="请选择" @change="partserch"
                        size="mini" style="width: 130px">
                        <el-option label="借用中" :value="1" key="1"></el-option>
                        <el-option label="已归还" :value="2" key="2"></el-option>
                        <el-option label="其他" :value="3" key="3"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.aimbrReadConfirmStatus" clearable placeholder="请选择"
                        @change="partserch" size="mini" style="width: 130px">
                        <el-option label="未确认" :value="1" key="1"></el-option>
                        <el-option label="已确认" :value="2" key="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.aimcId" placeholder="请选择分类" size="mini" clearable
                        @change="partserch">
                        <el-option v-for="item in aimcName_arr || []" :label="item.aimcName" :value="item.aimcId"
                            :key="item.aimcId">
                        </el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="primary" size="mini" style="margin-left: 10px" @click="batchWord"
                        v-if="formDatas.auName">借用手册签字表</el-button>
                    <el-button type="primary" size="mini" style="margin-left: 10px" @click="batchWord2"
                        v-if="formDatas.auName">
                        <<员工手册>>确认书
                    </el-button>
                    <!-- <el-dropdown size="mini" split-button type="warning" style="margin-left: 10px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增配件分类</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="aimbrId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑配件分类' : '新增配件分类'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="配件分类" prop="afcName">
                                <el-input v-model="form.aahRepairTime" style="width: 50%;"
                                    placeholder="请输入名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>

import { deleteAjInductionManualBorrowRecord, getAjInductionManualClassList, exportAjInductionManualBorrowRecordWordReturn, exportAjInductionManualBorrowRecordWord, getAjInductionManualBorrowRecordListAuNames, getAjInductionManualBorrowRecordList, updateAjInductionManualBorrowRecordReturn, exportAjAssetsHitch } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            userid: '',
            aimcName_arr: [],
            auNamesList: [],
            username: '',
            BreakDown: false,//处理故障
            dialog: false,
            edit: false,
            form: {
                aimbrId: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {

                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",

                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "借用人",
                    width: 120,
                    align: "center",
                    fixed: 'left',
                },
                {
                    field: "aimbName",
                    key: "aimbName",
                    title: "手册名称",
                     width: 120,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"

                                >
                                    {row.aimbName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "aimbSerialNumber",
                    key: "aimbSerialNumber",
                    title: "手册序列号",
                     width: 120,
                    align: "center",
                },
                {
                    field: "aimbrDateBorrow",
                    key: "aimbrDateBorrow",
                    title: "借用时间",
                     width: 140,
                    align: "center",
                },
                {
                    field: "aimbrSign",
                    key: "aimbrSign",
                    title: "签名图片",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aimbrSign ? <el-image ref="scrImg" id="scrimg" src={row.aimbrSign} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={[row.aimbrSign]}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },

                },
                {
                    field: "aimbrStatus",
                    key: "aimbrStatus",
                    title: "状态",
                     width: 120,
                    align: "center",

                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aimbrStatus == 1 ? <el-tag size="mini" type="danger" > 借用中 </el-tag> : row.aimbrStatus == 3 ? <el-tag size="mini" type="danger" > 其他 </el-tag> : <el-tag size="mini" type="success" > 已归还 </el-tag>
                                }

                            </span>
                        );
                    },

                },
                {
                    field: "aimbrReadConfirmSign",
                    key: "aimbrReadConfirmSign",
                    title: "阅读确认签名",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aimbrReadConfirmSign ? <el-image ref="scrImg" id="scrimg" src={row.aimbrReadConfirmSign} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={[row.aimbrReadConfirmSign]}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },

                },
                {
                    field: "aimbrReadConfirmStatus",
                    key: "aimbrReadConfirmStatus",
                    title: "阅读确认",
                     width: 120,
                    align: "center",

                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aimbrReadConfirmStatus == 1 ? <el-tag size="mini" type="danger" > 未确认 </el-tag> : row.aimbrReadConfirmStatus == 2 ? <el-tag size="mini" type="success" > 已确认 </el-tag>
                                        : <el-tag size="mini" type="info" > 不需要 </el-tag>
                                }

                            </span>
                        );
                    },

                },
                { field: "aimbrReadConfirmDate", key: "aimbrReadConfirmDate", title: "阅读确认时间", width: 160, align: "center" },
                { field: "aimbrHandlerUser", key: "aimbrHandlerUser", title: "归还经手人", width: 120, align: "center" },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 120,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aimbrStatus == 1 ? <el-button

                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleGuiHuan(row)}
                                    >
                                        归还
                                    </el-button> : <span></span>
                                }
                                {
                                    this.userid == 21 || this.userid == 1 ? <el-button

                                        size="mini"
                                        type="text"
                                        style="red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button> : <span></span>
                                }
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.userid = localStorage.getItem("userid");
        this.getList();
        this.username = localStorage.getItem("suName");
        getAjInductionManualBorrowRecordListAuNames().then((res) => {
            this.auNamesList = res.data;
        });
        getAjInductionManualClassList({ pageSize: 0 }).then(res => {
            this.aimcName_arr = res.data
        })
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
        },
        batchWord() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.openLoading();
                const idsList = [];
                this.tableData.forEach((item) => {
                    idsList.push(item.aimbrId);
                });
                exportAjInductionManualBorrowRecordWord({
                    aimbrIds: idsList.toString(),
                }).then((res) => {
                    if (res.status == 200) {
                        this.loadings.close();
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: "导出成功",
                        });
                        this.checkboxOption.selectedRowKeys =
                            this.selectedRowKeysCollection = [];
                    }
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                console.log("开始导出", this.selectedRowKeysCollection);
                this.openLoading();
                exportAjInductionManualBorrowRecordWord({
                    aimbrIds: this.selectedRowKeysCollection.toString(),
                }).then((res) => {
                    if (res.status == 200) {
                        this.loadings.close();
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: "导出成功",
                        });
                        this.checkboxOption.selectedRowKeys =
                            this.selectedRowKeysCollection = [];
                    }
                });
            }
        },
        batchWord2() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.openLoading();
                const idsList = [];
                this.tableData.forEach((item) => {
                    idsList.push(item.aimbrId);
                });
                exportAjInductionManualBorrowRecordWordReturn({
                    aimbrIds: idsList.toString(),
                }).then((res) => {
                    if (res.status == 200) {
                        this.loadings.close();
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: "导出成功",
                        });
                        this.checkboxOption.selectedRowKeys =
                            this.selectedRowKeysCollection = [];
                    }
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                console.log("开始导出", this.selectedRowKeysCollection);
                this.openLoading();
                exportAjInductionManualBorrowRecordWordReturn({
                    aimbrIds: this.selectedRowKeysCollection.toString(),
                }).then((res) => {
                    if (res.status == 200) {
                        this.loadings.close();
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: "导出成功",
                        });
                        this.checkboxOption.selectedRowKeys =
                            this.selectedRowKeysCollection = [];
                    }
                });
            }
        },
        handleGuiHuan(row) {
            var that = this
            if (row.aimbrReadConfirmStatus == 1) {
                that.$confirm("领用人未确认员工手册阅读确认书，请告知其前往钉钉工作台-未分组应用-公司资产处确认", "预警：", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = {
                            aimbrId: row.aimbrId,
                            aimbrHandlerUser: that.username
                        }
                        updateAjInductionManualBorrowRecordReturn(newForm).then(res => {
                            if (res.data) {
                                that.$message({
                                    type: "success",
                                    message: "归还成功!",
                                });

                                that.partserch()
                            }
                        })
                    }).catch(() => {

                    })
            } else {
                that.$confirm("是否确定要归还吗", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = {
                            aimbrId: row.aimbrId,
                            aimbrHandlerUser: that.username
                        }
                        updateAjInductionManualBorrowRecordReturn(newForm).then(res => {
                            if (res.data) {
                                that.$message({
                                    type: "success",
                                    message: "归还成功!",
                                });

                                that.partserch()
                            }
                        })
                    }).catch(() => {
                        that.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                exportAjAssetsHitch({ aimbrIds: this.selectedRowKeysCollection.toString(), exportType: 2, ...this.formDatas }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });
                        this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                    }
                })
            } else {
                this.openLoading()
                this.formDatas.exportType = 1
                exportAjAssetsHitch(this.formDatas).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            }
        },
        // 处理故障
        CloseBreakDown() {
            this.BreakDown = false;

            this.$refs['formRef'].resetFields();
        },

        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjInductionManualBorrowRecord({ aimbrId: row.aimbrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            this.form.aimbrId = row.aimbrId;
            this.BreakDown = true;
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjFittingsClass(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjFittingsClass(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {

            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aimbrId = row.aimbrId
                    console.log(jsonObj);
                    updateAjFittingsClass(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.aimbrId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.aimbrId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.aimbrId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.aimbrId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.aimbrId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjInductionManualBorrowRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjInductionManualBorrowRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjInductionManualBorrowRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>